import Avatar from 'storybookConfig/stories/cells/Avatar';
import { CommerceType } from 'types/models/company';

export const COMMERCE_TYPE_AVATAR_SIZE = '40px';

interface CommerceTypeAvatarProps {
  commerceType: CommerceType;
}

const getCommerceTypeDisplayLabel = (commerceType: CommerceType): string => {
  if (commerceType === CommerceType.Buyer) return 'Retailer';
  if (commerceType === CommerceType.Seller) return 'Supplier';
  return '';
};

const CommerceTypeAvatar = ({ commerceType }: CommerceTypeAvatarProps) => (
  <Avatar
    iconName={commerceType === CommerceType.Buyer ? 'domain' : 'store'}
    text={getCommerceTypeDisplayLabel(commerceType)}
    backgroundColor={commerceType === CommerceType.Buyer ? 'blue100' : 'purple100'}
    color={commerceType === CommerceType.Buyer ? 'blue700' : 'purple700'}
    borderColor={commerceType === CommerceType.Buyer ? 'blue200' : 'purple100'}
    size={COMMERCE_TYPE_AVATAR_SIZE}
  />
);

export default CommerceTypeAvatar;
